import { render, staticRenderFns } from "./NewsdetailContent.vue?vue&type=template&id=191996cd"
import script from "./NewsdetailContent.vue?vue&type=script&lang=js"
export * from "./NewsdetailContent.vue?vue&type=script&lang=js"
import style0 from "./NewsdetailContent.vue?vue&type=style&index=0&id=191996cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports